import React from 'react';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { SxProps } from '@mui/material/styles';
import { Title } from '../details/styledComponents';

interface Props {
    sx?: SxProps;
}

const RenderFetchingState: React.FC<Props> = props => {
    return (
        <Stack px={1} sx={props.sx}>
            <Title>Overall Score</Title>
            <Skeleton variant="rounded" animation="wave" height={20} />
        </Stack>
    );
};

export default RenderFetchingState;
